import { Injectable } from '@angular/core';

import { ModifierTypes } from 'models/layout-mod.model';

@Injectable({
  providedIn: 'root'
})
export class StylingService {
  concatLayoutModifiers(base: string, modifiers: ModifierTypes[]): string {
    return modifiers
      ? (modifiers as string[]).reduce((str: string, mod: string) => `${str}${base}_${mod} `, '').trim()
      : '';
  }
}
